///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2021, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2021 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////
/* eslint-disable no-unused-vars */
import { Viewer } from "../Viewer";
import { ZoomAction } from "./Actions/ZoomAction";
import { OdBaseDragger } from "./Common/OdBaseDragger";

export class OdZoomDragger extends OdBaseDragger {
  private _zoomAction: ZoomAction;
  protected pressX: number;
  protected pressY: number;

  constructor(subject: Viewer) {
    super(subject);
    this.autoSelect = true;
    this.press = false;
    this._zoomAction = new ZoomAction(this.m_module, this.subject);
  }

  override start(x: number, y: number): void {
    this.press = true;
    this.pressX = x;
    this.pressY = y;
    this.beginInteractivity();
  }

  override drag(x: number, y: number, dltX: number, dltY: number): void {
    if (this.press) {
      const ZOOM_SPEED = 0.025;
      const zoomFactor = dltY > 0 ? 1 + ZOOM_SPEED : 1 - ZOOM_SPEED;
      this._zoomAction.action(this.pressX, this.pressY, zoomFactor);
    }
  }

  override end(): void {
    this.press = false;
    this.endInteractivity();
  }
}
